import type { IconSvgObject } from './types';

const UserRoundCheckIcon: IconSvgObject = [
  ["path", { d: "M15 8C15 5.23858 12.7614 3 10 3C7.23858 3 5 5.23858 5 8C5 10.7614 7.23858 13 10 13C12.7614 13 15 10.7614 15 8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 20C3 16.134 6.13401 13 10 13C11.9587 13 13.7295 13.8045 15 15.101", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 18.5C13 18.5 14.3485 19.0067 15 21C15 21 18.1765 16 21 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default UserRoundCheckIcon;
